import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { SensorsPage } from 'src/sensors/list/SensorsPage.tsx';
import { PrefetchSensorsCheckout } from 'src/sensors/checkout/PrefetchSensorsCheckout.tsx';
import { SharePage } from 'src/sensors/SharePage.tsx';
import { PATHS } from 'src/sensors/common/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { RouteObject } from 'react-router/dist/lib/context';
import { PageLegacy } from 'src/sensors/common/PageLegacy.tsx';
import { PrefetchAccessories } from 'src/sensors/accessories/PrefetchAccessories.tsx';

const errorElement = <ErrorBoundary/>;

export const SensorRoutes: RouteObject[] = [
    {
        path: `${PATHS.Sensors}/:page`,
        element: <PageLegacy pathname={PATHS.Sensors}/>,
        errorElement,
    },
    {
        path: PATHS.Sensors,
        element: <SensorsPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:sensorLabel/:page`,
        element: <PageLegacy pathname={PATHS.Accessories}/>,
        errorElement,
    },
    {
        path: PATHS.Accessories,
        element: <PrefetchAccessories/>,
        errorElement,
    },
    {
        path: `${PATHS.Checkout}/:sensorLabel/:page`,
        element: <PageLegacy pathname={PATHS.Checkout}/>,
        errorElement,
    },
    {
        path: PATHS.Checkout,
        element: <PrefetchSensorsCheckout/>,
        errorElement,
    },
];

export const router = () => createHashRouter([
    ...SensorRoutes.map((route) => ({
        ...route,
        element: <Outlet/>,
        children: createChildrenRoute(route.element),
    } as RouteObject)),
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(PATHS.Sensors),
        errorElement,
    },
]);
